import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";

// function App2() {
//   const { t } = useTranslation()
//   return <h2>{t('navbar.howitwork')}</h2>;
// }

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <React.Suspense>
        <React.StrictMode>
          {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
            <App />
          {/* </BrowserRouter> */}
        </React.StrictMode>
        {/* <App2 />     */}
      </React.Suspense>
    </PersistGate>
  </Provider>
);
